/* @ngInject */
function AssetPreviewVersionControlController ($scope, $rootScope, $timeout, $q, $interval, $translate, UdsModalService, NewAssetService, AssetService, AssetPreviewService, ToastService, UploadService, SegmentService) {
  const getConfirmRestoreAssetVersionController = () => $q.when(import('../../../repository/dialogs/confirm-restore-asset-version/confirm-restore-asset-version-dialog.controller'))

  $scope.flags = {
    loading: true,
    uploadingNewVersion: false
  }
  $scope.assetVersions = []
  $scope.otherVersions = []
  $scope.currentVersion = {}

  const api = {
    _getAssetVersions,
    _formatVersionsResponse,
    _validateHasThumbnail,
    _getThumbnailUrl,
    _formatDate
  }
  this.getApi = () => api

  activate()
  function activate () {
    api._getAssetVersions($scope.template.assetId)

    $timeout(() => {
      $scope.flags.loading = false
    }, 500)
  }

  function _getAssetVersions (assetId) {
    $scope.flags.loading = true

    return NewAssetService.getAssetVersions(assetId)
      .then((response) => {
        const formattedVersions = api._formatVersionsResponse(response.rows)
        $scope.assetVersions = formattedVersions
        $scope.otherVersions = formattedVersions.slice(1)
        $scope.currentVersion = formattedVersions[0]
      }).finally(() => {
        $scope.flags.loading = false
      })
  }

  function _formatVersionsResponse (versions) {
    return versions.map((asset, index) => {
      api._validateHasThumbnail(asset.id, asset.version)

      return {
        ...asset,
        formattedDate: api._formatDate(asset),
        thumbnailUrl: api._getThumbnailUrl(asset),
        versionName: index === 0 ? $translate.instant('repository.preview.versionsTab.currentVersion') : `${$translate.instant('version')} ${asset.version}`
      }
    })
  }

  function _formatDate (asset) {
    moment.locale($translate.preferredLanguage())

    return `${moment(asset.createdAt).format('DD MMM, YYYY')}`
  }

  function _getThumbnailUrl (asset) {
    return NewAssetService.getAssetThumbnailUrl(asset.id, 'LOW', {
      version: asset.version,
      includeDateAsQueryString: true
    })
  }

  function _validateHasThumbnail (assetId, assetVersion) {
    const interval = $interval(() => {
      NewAssetService.checkAssetHasThumb(assetId, 'LOW', assetVersion).then((hasThumb) => {
        if (!hasThumb) {
          return
        }

        $interval.cancel(interval)
        const asset = $scope.assetVersions.find((asset) => asset.version === assetVersion)
        asset.thumbnailUrl = api._getThumbnailUrl(asset)
      })
    }, 8000)
  }

  $scope.downloadAsset = (assetVersion) => {
    AssetService.downloadAsset(assetVersion.id, null, assetVersion.version)
  }

  $scope.restoreVersion = (assetVersion) => {
    getConfirmRestoreAssetVersionController().then(({ ConfirmRestoreAssetVersionDialogController }) => {
      const confirmRestoreAssetVersion = UdsModalService.createModal({
        controller: ConfirmRestoreAssetVersionDialogController,
        modalName: 'confirmRestoreAssetVersionDialog',
        data: {
          assetId: assetVersion.id,
          assetVersion: assetVersion.version
        },
        onClose: (data) => {
          if (!data) {
            return
          }

          if (data.success) {
            ToastService.defaultSuccessToast()
            $timeout(() => {
              api._getAssetVersions($scope.template.assetId)
              $rootScope.$emit('asset-preview-dialog.reload-preview-details')
              $rootScope.$broadcast('workflow.reloadAttachments')
            })

            return
          }

          ToastService.defaultErrorToast()
        }
      })

      confirmRestoreAssetVersion.open()
    })
  }

  $scope.getFileUploadAcceptance = (contentType) => {
    if (contentType.includes('video')) {
      return 'video/*'
    }

    return contentType
  }

  $scope.uploadNewVersion = (file) => {
    if (!file) {
      return
    }

    if (!$scope.template.s3Key) {
      // show error toast
      ToastService.defaultErrorToast()
      return
    }

    $scope.flags.uploadingNewVersion = true

    UploadService.uploadToS3(file, {
      existentS3Key: $scope.template.s3Key,
      generateThumbnailSync: $scope.template.s3Key.includes('-sync')
    }).then(() => {
      $rootScope.$emit('asset-preview-dialog.reload-preview-details')
      SegmentService.track('file-version-upload')
      api._getAssetVersions($scope.template.assetId)
    }).finally(() => {
      $scope.flags.uploadingNewVersion = false
    })
  }

  $scope.closeVersionControl = () => {
    $timeout(() => {
      $scope.previewFlags.showVersionControl = false
    }, 0, true)
  }

  $scope.openAssetQuickPreview = (assetVersion) => {
    NewAssetService.getAssetDetails(assetVersion.id).then((asset) => {
      asset.version = assetVersion.version
      asset.name = assetVersion.versionName

      if (AssetPreviewService.assetQuickPreviewIsOpen()) {
        AssetPreviewService.closePreview()
      }

      AssetPreviewService.openAssetQuickPreview({
        currentAsset: asset,
        assets: []
      })
    })
  }
}

export { AssetPreviewVersionControlController }
